import type { User } from '$types/user';
import type { Address } from '$types/address';
import { loadUser } from '$utils/loadUser';
import type { CirclesAvatarFromEnvio } from '$types/envioTypes';
import { SharedCache, StateItem } from './sharedCache.svelte';

const SECONDS_TO_EXPIRE = 90;

export class Users extends SharedCache<Address, User> {
  protected getDefaultExpirationSeconds(): number {
    return SECONDS_TO_EXPIRE;
  }
  protected keyToString(key: Address): string {
    return String(key);
  }

  public async byAddress(
    address: Address,
    circlesAvatar?: CirclesAvatarFromEnvio,
  ): Promise<StateItem<User>> {
    return this.get(address, async (addr) => {
      return await loadUser(addr, circlesAvatar);
    });
  }

  public invalidateAddress(address: Address) {
    this.invalidate(address);
  }
}

export const users = new Users();
